export default () => ({ serviceWorkerRegistered: true });
